<div class="yes-no-radio-button">
  <ng-container *ngFor="let option of options">
    <p-radioButton
      [inputId]="option.code.toString()"
      [value]="option.code"
      [ngModel]="selectedValue"
      (ngModelChange)="onSelectValue($event)"
      [name]="name"
      (onBlur)="markAsTouched()"
    ></p-radioButton>
    <label [for]="option.code.toString()" class="yes-no-radio-button__label">
      {{ option.name }}
    </label>
  </ng-container>
</div>
